import { render, staticRenderFns } from "./LevelStage.vue?vue&type=template&id=52796050&scoped=true"
import script from "./LevelStage.vue?vue&type=script&lang=js"
export * from "./LevelStage.vue?vue&type=script&lang=js"
import style0 from "./LevelStage.vue?vue&type=style&index=0&id=52796050&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52796050",
  null
  
)

export default component.exports